"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _acsReportsSdk = require("@adsk/acs-reports-sdk");
var _getRequestConfig = _interopRequireDefault(require("../../../helpers/getRequestConfig"));
var _QuickReportsPanelContext = _interopRequireDefault(require("../QuickReportsPanelContext"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const useFetchServiceLimits = service => {
  const {
    isOpen
  } = (0, _react.useContext)(_QuickReportsPanelContext.default);
  const [serviceLimits, setServiceLimits] = (0, _react.useState)({});
  (0, _react.useEffect)(() => {
    if (isOpen && service && (0, _isEmpty.default)(serviceLimits)) {
      const requestConfig = (0, _getRequestConfig.default)();
      (0, _acsReportsSdk.fetchServiceLimits)({
        service
      }, requestConfig).then(setServiceLimits).catch(err => err);
    }
  }, [service, isOpen]);
  return serviceLimits;
};
var _default = exports.default = useFetchServiceLimits;